<template>
  <ion-page class="listening-train-page" :class="theme">
    <ion-content>
      <div class="header">
        <div class="left" @click="back('back')">
          <img class="icon-back" :src="imageMap.back" alt="" />
          <span>返回</span>
        </div>
        <span class="title">听口训练{{listenStore.listenPrepare?'(备课)':''}}</span>
      </div>
      <p class="course-name">{{ courseName }}</p>
      <div class="listening-list">
        <div
          class="listening-item"
          :style="item.expanded ? 'border-bottom:0' : ''"
          v-for="(item, index) in listeningItems"
        >
          <div class="listening-item_header">
            <ion-label>{{ item.courseName }}</ion-label>
            <img
              class="arrow-icon"
              :class="{ 'transform-rotate': !item.expanded }"
              :src="imageMap.arrow_top"
              @click="toggleItem(index)"
            />
          </div>
          <!-- 展开的子项 -->
          <div v-if="item.expanded" class="sub-items-container">
            <div
              v-for="(subItem, subIndex) in item.summary"
              :key="subIndex"
              class="sub-item"
              @click="openCourse(subItem)"
            >
              <div class="sub-item_left">
                <ion-label class="subItem-title">{{ subItem.summaryName }}</ion-label>
                <div style="display: flex; align-items: center">
                  <div class="progress">
                    <span
                      class="progress-slider"
                      :style="'width:' + subItem.progress * 100 + '%'"
                    ></span>
                  </div>
                  <span style="font-size: 10px">{{ subItem.progress * 100 + "%" || "0%" }}</span>
                </div>
              </div>
              <img class="icon-arrow-right" :src="imageMap.sub_arrow_right" alt="" />

              <!--    正在学标志          -->
              <img
                v-if="subItem.currentFlag"
                class="icon-learning"
                src="@/assets/grammar/icon-learning.svg"
              />
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup>
import { IonPage, IonContent, IonLabel, modalController } from "@ionic/vue";
import { defineProps, onMounted, ref, computed } from "vue";
import ListeningIndex from "./Index.vue";
import ListenPrepareIndex from "./ListenPrepareIndex.vue";
import http from "@/js/http";
import store from "@/js/store";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import { imageConfig } from "./components/ThemeTag/imageConfig";
import MessageDialog from "@/views/listening/components/MessageDialog.vue";

const props = defineProps(["courseId", "studentId"]);

const listeningItems = ref([]);

const listenStore = useListenConfigStore();

const theme = computed(() => listenStore.theme);

const imageMap = computed(() => imageConfig[theme.value]);

const courseName = ref("");

const back = () => {
  modalController.dismiss();
};

// 切换主目录项展开/折叠
const toggleItem = (idx) => {
  // 如果点击的是已展开的项，则不做任何操作
  listeningItems.value[idx]["expanded"] = !listeningItems.value[idx]["expanded"];
};

const openCourse = async (item) => {
  if (item.progress == 1 && !listenStore.listenPrepare) {
    const msgModal = await modalController.create({
      component: MessageDialog,
      componentProps: {
        title: "重新训练",
        message: "已完成训练，是否重新开始",
        keyText: item.summaryName,
      },
      cssClass: "center_modal_controller_class_message",
      backdropDismiss: false,
    });
    await msgModal.present();
    msgModal.onDidDismiss().then(({ data }) => {
      if (data === "confirm") {
        showListenIndex(item, 1);
      }
    });
  } else {
    showListenIndex(item, 0);
  }
};

const showListenIndex = async (item, review) => {
  const components = listenStore.listenPrepare ? ListenPrepareIndex : ListeningIndex
  const modal = await modalController.create({
    component: components,
    componentProps: {
      topicType: item.topicType,
      listenId: item.listenId,
      linkType:  listenStore.listenPrepare || review ? 1 : item.linkType || 1,
      courseId: props.courseId,
      studentId: props.studentId,
      summaryName: item.summaryName,
    },
    cssClass: "modal_controller_class",
  });
  modal.onDidDismiss().then(({ data }) => {
    if (data === "back") {
      getDirectoryData();
    }
  });
  return modal.present();
};

const getDirectoryData = async () => {
  const appointment = store.getAppointment();
  try {
    const { data } = await http.post("/listen/listenchapter/getListenChapterIndex", {
      courseId: props.courseId,
      aptmId: appointment.aptmId,
      studentId: props.studentId,
    });
    if (data.code === 200) {
      listeningItems.value = data.data;
      listeningItems.value.forEach((item) => {
        const subItem = item.summary.find((i) => i.currentFlag);
        if (subItem) {
          item.expanded = true;
        }
      });
      courseName.value = listeningItems.value[0].dataName;
    }
  } catch (err) {
    console.error(err);
  }
};

onMounted(() => {
  getDirectoryData();
});
</script>

<style lang="less" scoped>
@import "components/ThemeTag/listenTheme";
.listening-train-page {
  background-color: var(--page-background-color);
  .header {
    font-size: 1.01rem;
    position: relative;
    height: 2.8rem;
    color: var(--page-title-color);
    padding: 0 0.95rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    z-index: 99;
    background-color: var(--page-background-color);
    .icon-back {
      width: 0.38rem;
      height: 0.89rem;
      margin-right: 0.45rem;
      vertical-align: baseline;
    }
    .title {
      font-size: 1.08rem;
      font-weight: 600;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .course-name {
    font-size: 0.95rem;
    font-weight: 500;
    margin: 0.635rem 0;
    text-align: center;
    color: var(--page-sub-title-color);
  }
  .listening-list {
    padding: 0 0.8rem 0.8rem;
    color: var(--page-title-color);
    display: flex;
    flex-direction: column;
  }
  .listening-item {
    font-size: 1.02rem;
    font-weight: 400;
    padding: 0.86rem 0;
    border-bottom: 1px solid var(--chapter-border-bottom);

    &:last-child {
      border-bottom: 0;
    }

    &_header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      .transform-rotate {
        transform: rotate(180deg);
        transition: transform 0.3s;
      }
    }
  }
  .arrow-icon {
    width: 1.28rem;
    height: 1.28rem;
    border-radius: 50%;
    transition: transform 0.3s;
  }
  .arrow-right {
    transform: rotate(90deg);
  }
  .sub-items-container {
    border-radius: 0.63rem;
    background: var(--sub-bg);
    padding: 0 0.63rem 0 0.63rem;
    margin-top: 0.86rem;
    .sub-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0.63rem 0;
      border-bottom: 1px dashed var(--sub-border-bottom);
      position: relative;
      .icon-learning {
        width: 3.31rem;
        height: 2.1rem;
        position: absolute;
        right: 2.23rem;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .sub-item_left {
      font-size: 0.89rem;
      .subItem-title {
        margin-bottom: 0.57rem;
        line-height: 1.21rem;
        display: block;
      }
      .progress {
        width: 6.35rem;
        height: 0.5rem;
        position: relative;
        border-radius: 0.5rem;
        background-color: var(--progress-bg);
        margin-right: 0.6rem;
        .progress-slider {
          height: 0.5rem;
          background: var(--progress-track);
          width: 0;
          position: absolute;
          top: 0;
          left: 0;
          border-radius: 0.5rem;
        }
      }
    }
    .icon-arrow-right {
      width: 0.89rem;
      height: 0.89rem;
    }
  }
}
</style>
